import Vue from 'vue'

const ActionTypes = {
    SMALL_SCREEN: 'SMALL_SCREEN',
    NOTIFY_CUSTOMER_CHANNELS: 'NOTIFY_CUSTOMER_CHANNELS',
    NOTIFY_ADMIN_CHANNELS: 'NOTIFY_ADMIN_CHANNELS',
    BOT_STAFF: 'BOT_STAFF',
    GET_BOT_STAFF: 'GET_BOT_STAFF',
    CHANGE_CHAT_VIEW: 'CHANGE_CHAT_VIEW',
    BOT_STATUS: 'BOT_STATUS',
    SUPPORTER: 'SUPPORTER',
    ACTIVE_STAFF: 'ACTIVE_STAFF',
    BOT_LIST: 'BOT_LIST',
    BOT_LIST_PIN: 'BOT_LIST_PIN',
    CHANNEL: 'CHANNEL',
    CHAT_TAB: 'CHAT_TAB',
    BOT: 'BOT',
    LAST_SESSION_ID: 'LAST_SESSION_ID',
    SET_LIGHT_BOX_DATA_THEN_SHOW: 'SET_LIGHT_BOX_DATA_THEN_SHOW',
    GET_ALL_AUTO_ASSIGN_CONFIG: 'GET_ALL_AUTO_ASSIGN_CONFIG',
    GET_UNREAD_USER_NOTIFY: 'get_unread_user_notify',
    AGENT_CONFIG: 'agent_config',
    MESSAGE_CACHE: 'MESSAGE_CACHE',
    DEL_MESSAGE_CACHE: 'DEL_MESSAGE_CACHE',
    USER: 'USER',
    TOKEN: 'TOKEN',
    QUOTE_MESSAGE: 'QUOTE_MESSAGE',
    DEL_QUOTE_MESSAGE: 'DEL_QUOTE_MESSAGE',
};

Vue.prototype.$ActionTypes = ActionTypes;

export default ActionTypes
